import * as React from 'react'
import { ReactElement, useMemo } from 'react'
import { Button, makeStyles, mergeClasses, Text, tokens } from '@fluentui/react-components'
import { OpenRegular } from '@fluentui/react-icons'
import { ViewFileProps } from '../ViewFile'
import { useApplicationStyles } from '../../../../pages/App'
import { useTranslation } from 'react-i18next'
import { AIAgentTimelineDto, FileAIAgentDto, FileAIAgentProps } from './FileAIAgentOverview'
import { compareDate } from '../../../../helpers/dateHelper'
import FormattedDateBadge from '../../../../components/Date/FormattedDateBadge'

const useStyles = makeStyles({
    rows: {
        display: 'grid',
        gridTemplateColumns: '70px 1fr',
        gridTemplateRows: 'minmax(40px, 1fr)',
        gap: tokens.spacingHorizontalS,
    },
})

export function FileAIAgentTimeline(
    props: Partial<FileAIAgentProps> & ViewFileProps & { currentAIAgent: FileAIAgentDto; timeline: AIAgentTimelineDto },
): ReactElement {
    const appStyles = useApplicationStyles()
    const styles = useStyles()
    const { t: translate } = useTranslation()

    const timelineEvents = useMemo(() => {
        return props.timeline.events.sort((a, b) => compareDate(b.date, a.date))
    }, [])

    return (
        <div className={mergeClasses(appStyles.flexColumn, appStyles.gapS)}>
            <div className={mergeClasses(appStyles.flexRow, appStyles.gapS)}>
                <Button
                    appearance="secondary"
                    icon={<OpenRegular />}
                    onClick={() => window.open(`${process.env.LEGALPA_APP_URL}/dossiers/${props.currentAIAgent.externalId}/timeline`, '_blank')}
                >
                    {translate(`file.pivot.aiagent.${props.agent.toLowerCase().replaceAll('_', '-')}.interaction.timeline.open`)}
                </Button>
            </div>
            <div className={mergeClasses(styles.rows)}>
                {timelineEvents.map((event, index) => (
                    <>
                        <FormattedDateBadge key={`${index}-0`} date={event.date} />
                        <Text key={`${index}-1`}>{event.description}</Text>
                    </>
                ))}
            </div>
        </div>
    )
}
